import { AxiosRequestConfig } from 'axios';
import * as $protobuf from 'protobufjs/minimal';
import httpService from '../utils/request';
import { retrieveHttpsUrl } from './urls';
import { live } from './proto';
import newBuffer = $protobuf.util.newBuffer;
import LiveService = live.LiveService;

export const protobufAxiosConfig: AxiosRequestConfig = {
  method: 'post',
  headers: {
    'Content-Type': 'application/x-protobuf',
    'X-Requested-With': 'XMLHttpRequest',
  },
  responseType: 'arraybuffer',
};

// 基于 HTTP 实现的 RPC
export const httpRpcImpl = (
  // eslint-disable-next-line @typescript-eslint/ban-types
  method,
  requestData,
  callback
) => {
  const url = retrieveHttpsUrl(method.name);

  httpService
    .post(url, newBuffer(Array.from(requestData)), protobufAxiosConfig)
    .then((resp) => {
      const numberArray: number[] = resp.data;
      callback(null, newBuffer(numberArray));
    })
    .catch((reason) => {
      callback(reason, null);
    });
};

export const service = LiveService.create(httpRpcImpl);
